import { AxiosError } from "axios";
import { action, makeObservable, observable } from "mobx";

const helpEmailAddress = 'jacob@focus.dev';

export interface ErrorDetail {
  title: string;
  description?: string;
  originalMessage?: string;
}

export class ErrorStore {
  @observable hasError: boolean = false;
  @observable error: Error;
  @observable errorDetail: ErrorDetail | undefined;

  constructor() {
    makeObservable(this);
  }

  isNetworkError() {
    if (this.error instanceof AxiosError) {
      return this.error.code === 'ERR_NETWORK';
    }

    return false;
  }

  getHelpEmail() {
    return helpEmailAddress;
  }

  @action handleError = (error: any) => {
    this.hasError = true;
    this.error = error;

    this.errorDetail = {
      title: 'Something went wrong.',
      description: '',
      originalMessage: error.message
    };

    console.error(error);
  }

  @action clearError = () => {
    this.hasError = false;
    this.errorDetail = undefined;
  }
}